module.exports = __webpack_public_path__ + "media/honey-icons/icon-thermostat-gen-3-64360241.svg";